/**
 * The main pointer's kind (`pointer: coarse` for a finger, `fine` for a mouse
 * or pen), kept current: attaching a trackpad to a tablet changes it.
 */
import { useSyncExternalStore } from "react";
import type { PointerKind } from "../viewport/navHints";

const COARSE = "(pointer: coarse)";

function subscribe(listener: () => void): () => void {
  const query = window.matchMedia(COARSE);
  query.addEventListener("change", listener);
  return () => {
    query.removeEventListener("change", listener);
  };
}

function snapshot(): PointerKind {
  return window.matchMedia(COARSE).matches ? "coarse" : "fine";
}

export function usePointerKind(): PointerKind {
  return useSyncExternalStore(subscribe, snapshot, () => "fine");
}
